
export default {
    props: {
        slug: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        category: {
            type: String,
            default: '',
        },
        separator: Boolean,
        separatorColor: {
            type: String,
            default: '',
        },
        isLanding: Boolean,
        text: {
            type: String,
            default: '',
        },
        pageTitle: {
            type: String,
            default: '',
        },
    },

    computed: {
        hero() {
            if (this.slug) return `/guides/${this.slug}/hero.jpg`
            return ''
        },
    },
}
